document.addEventListener('click',event=>{
  const button=event.target.closest('[data-sun-image]');
  if(!button)return;
  const gallery=button.closest('.sun-gallery');
  gallery.querySelector('[data-sun-main]').src=button.dataset.sunImage;
  gallery.querySelector('[data-sun-main]').alt=button.dataset.sunAlt;
  gallery.querySelector('[data-sun-zoom]').href=button.dataset.sunFull;
  gallery.querySelectorAll('[data-sun-image]').forEach(el=>el.setAttribute('aria-pressed',String(el===button)));
});
document.addEventListener('change',event=>{
  const input=event.target.closest('input[data-sun-price]');
  if(!input)return;
  const root=input.closest('[data-sun-product]');
  root.querySelector('.sun-price').textContent=input.dataset.sunPrice;
  const available=input.dataset.sunAvailable==='true';
  const brandingPreview=root.hasAttribute('data-sun-branding-demo');
  const button=root.querySelector('[data-sun-buy]');
  button.disabled=brandingPreview||!available;
  button.textContent=available?'Add to cart':'Coming soon';
  const note=root.querySelector('[data-sun-note]');
  if(note&&!brandingPreview){note.hidden=available;note.textContent=available?'':'Orders are not yet open.';}
  const url=new URL(location.href);url.searchParams.set('variant',input.value);history.replaceState({},'',url);
});

document.addEventListener('keydown',event=>{
  const button=event.target.closest('[data-sun-image]');
  if(!button||!['ArrowUp','ArrowDown','Home','End'].includes(event.key))return;
  const buttons=[...button.closest('.sun-thumbnails').querySelectorAll('[data-sun-image]')];
  let index=buttons.indexOf(button);
  if(event.key==='Home')index=0;
  else if(event.key==='End')index=buttons.length-1;
  else index=(index+(event.key==='ArrowDown'?1:-1)+buttons.length)%buttons.length;
  event.preventDefault();buttons[index].focus();buttons[index].click();
});
